import {TreeConfig} from './tree.model';
import {UserPermissions} from './user-permissions.model';

export interface SongConfig {
  projectId?: string;
  sampleRate?: number;
}

export type SongEntity = SongConfig & TreeConfig & UserPermissions;
